export default __webpack_public_path__ + "static/media/JPG輪播1-2.61be075b.jpg";